import { Field, FieldProps } from 'formik';

import { Classes, TextAreaProps } from '@blueprintjs/core';

import { FormGroup } from '../form/Form';
import { TextArea } from '../form/textarea';
import { FieldError } from './field-error';
import { styled } from 'styled-components';

export interface IFormikTextAreaControlProps {
  name: string;
  rows: number;
  label: string;
  required?: boolean;
  placeholder?: string;
  helperText?: string;
  disabled?: boolean;
  hideValidationErrors?: boolean;
}

const StyledFormikTextarea = styled(TextArea)`
  &.${Classes.INPUT} {
    border: 1px solid ${({ theme }) => theme.colors.mono.ui04};
  }
`;

export const FormikTextAreaControl = (
  props: IFormikTextAreaControlProps & Omit<TextAreaProps, 'id' | 'value' | 'onChange'>
) => {
  const { name, rows, label, required, helperText, placeholder, disabled, hideValidationErrors, ...textAreaProps } =
    props;

  return (
    <FormGroup label={label} labelFor={name} helperText={helperText} $isRequired={required}>
      <Field name={name}>
        {(fieldProps: FieldProps) => (
          <StyledFormikTextarea
            {...textAreaProps}
            id={name}
            placeholder={placeholder}
            rows={rows}
            disabled={disabled}
            value={fieldProps.field.value}
            onChange={fieldProps.field.onChange}
          />
        )}
      </Field>
      {!hideValidationErrors && <FieldError name={name} />}
    </FormGroup>
  );
};
